<div mat-dialog-content class="tos-mat-dialog-content">
    <div class="restriction-box">
        <div class="box-boder">
            <app-locale localeKey="RESTRICTION" localeView="{{view}}"></app-locale>
            <div class="buttons-flex-center">
                <button class="btn btn-primary btn-group" (click)="onContinueOptAction(true)">
                    <app-locale localeKey='RESTRICTION_BTN' localeView="{{view}}"></app-locale>
                </button>
                <button class="btn btn-success btn-group" (click)="onContinueOptAction(false)">
                    <app-locale localeKey='CANCEL_BTN' localeView="IFRAME"></app-locale>
                </button>
            </div>
        </div>
    </div>
</div>